// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.container.report {
  max-width: 800px;
  margin-bottom: 30px;
  font-family: sans-serif;
  font-size: 10.5pt;
}

.title {
  font-weight: bold;
  text-decoration: underline;
}

.caption-bold {
  font-weight: bold;
}

.cell {
  height: 1.5em;
  overflow: hidden;
}
.cell.value {
  text-align: center;
  border-bottom: 1px solid black;
}

.new-section {
  margin-top: 10px;
}

.dark-pale {
  background-color: #feffa4 !important;
}

.divider {
  background-color: #cccccc !important;
}

.nobr {
  white-space: nowrap;
}

.width20 {
  width: 20px;
}

.width100px {
  width: 100px;
}

.width155 {
  width: 155px;
}

.width160px {
  width: 160px;
}

.width200px {
  width: 200px;
}

.width730px {
  width: 730px;
}

table.wide {
  width: 730px;
}

table.printable {
  font-size: 10.5pt;
  border-spacing: 0;
  border-style: solid;
  border-color: black;
  border-collapse: collapse;
  margin: 3px 0;
  page-break-inside: avoid;
}
table.printable th, table.printable td {
  border-width: 1px;
  padding: 0 3px;
  border-style: solid;
  border-color: black;
  page-break-inside: avoid;
}
table.printable th.text-center {
  text-align: center;
}
table.printable th.normalFont {
  font-weight: normal;
}

table.content-top td {
  vertical-align: top;
}

table caption {
  padding: 0;
}

div.pagebreak {
  page-break-after: always;
  page-break-inside: avoid;
}

hr.hiddenprint {
  margin: 8px 0;
  border-top: 1px dashed #ccc;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/worksheet/job-worksheet.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAMA;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,0BAAA;AAHF;;AAMA;EACE,iBAAA;AAHF;;AAMA;EACE,aAAA;EACA,gBAAA;AAHF;AAKE;EACE,kBAAA;EACA,8BAAA;AAHJ;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,oCAAA;AAJF;;AAOA;EACE,oCAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAQA;EAAc,WAAA;AAJd;;AAKA;EAAc,YAAA;AADd;;AAEA;EAAc,YAAA;AAEd;;AADA;EAAc,YAAA;AAKd;;AAJA;EAAc,YAAA;AAQd;;AAPA;EAAc,YAAA;AAWd;;AATA;EACE,YAAA;AAYF;;AATA;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,wBAAA;AAYF;AAVE;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;AAYJ;AATE;EAAiB,kBAAA;AAYnB;AAXE;EAAiB,mBAAA;AAcnB;;AAXA;EACE,mBAAA;AAcF;;AAXA;EACE,UAAA;AAcF;;AAXA;EACE,wBAAA;EACA,wBAAA;AAcF;;AAXA;EACE,aAAA;EACA,2BAAA;AAcF","sourcesContent":[":host {\n  display: block;\n}\n\n// ------------------------------------------------------------------\n// Worksheet print layout\n// ------------------------------------------------------------------\n\n.container.report {\n  max-width: 800px;\n  margin-bottom: 30px;\n  font-family: sans-serif;\n  font-size: 10.5pt;\n}\n\n.title {\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n.caption-bold {\n  font-weight: bold;\n}\n\n.cell {\n  height: 1.5em;\n  overflow: hidden;\n\n  &.value {\n    text-align: center;\n    border-bottom: 1px solid black;\n  }\n}\n\n.new-section {\n  margin-top: 10px;\n}\n\n.dark-pale {\n  background-color: #feffa4 !important;\n}\n\n.divider {\n  background-color: #cccccc !important;\n}\n\n.nobr {\n  white-space: nowrap;\n}\n\n// Fixed-width helpers (ported from report.scss)\n.width20    { width: 20px; }\n.width100px { width: 100px; }\n.width155   { width: 155px; }\n.width160px { width: 160px; }\n.width200px { width: 200px; }\n.width730px { width: 730px; }\n\ntable.wide {\n  width: 730px;\n}\n\ntable.printable {\n  font-size: 10.5pt;\n  border-spacing: 0;\n  border-style: solid;\n  border-color: black;\n  border-collapse: collapse;\n  margin: 3px 0;\n  page-break-inside: avoid;\n\n  th, td {\n    border-width: 1px;\n    padding: 0 3px;\n    border-style: solid;\n    border-color: black;\n    page-break-inside: avoid;\n  }\n\n  th.text-center { text-align: center; }\n  th.normalFont  { font-weight: normal; }\n}\n\ntable.content-top td {\n  vertical-align: top;\n}\n\ntable caption {\n  padding: 0;\n}\n\ndiv.pagebreak {\n  page-break-after: always;\n  page-break-inside: avoid;\n}\n\nhr.hiddenprint {\n  margin: 8px 0;\n  border-top: 1px dashed #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
